import apiClient from "./client";

export async function login(email) {
  return apiClient.post("/auth/login", { email });
}

export async function requestOneTimeCode(email) {
  return apiClient.post("/auth/login/code", { email });
}

export async function verifyOneTimeCode(email, code) {
  return apiClient.post("/auth/login/code/verify", { email, code });
}

export async function verifyMagicLink(token) {
  return apiClient.get(`/auth/verify/${token}`);
}

export async function confirmMinecraftLink(token) {
  return apiClient.get(`/auth/link-minecraft/${token}`);
}

export async function getMe() {
  return apiClient.get("/auth/me");
}

export async function logout() {
  const refreshToken = apiClient.refreshToken;
  apiClient.clearTokens();
  try {
    await apiClient.post("/auth/logout", { refreshToken });
  } catch {
    // Logout is best-effort
  }
}
